import URI from 'urijs';
import { _ } from 'wgnet-awesomejs';

import BaseCaptchaField from 'registration/js/base/fields/captcha';
import mobile from 'wgnet-awesomejs/lib/mobile';

import template from 'registration/templates/dark/fields/captcha.html';

const CaptchaField = BaseCaptchaField.extend({
    name: 'signin-captcha-field',
    template,
    enableInputNumberCheck: false,
    isWowsForm: _.extract('Settings.Registration.gameModificatorIsWows', false),
    getImageSrc({ url }) {
        if (mobile().useMobile) {
            return URI(url).addSearch('theme', 'dark_mobile').toString();
        }
        if (this.isWowsForm) {
            return URI(url).addSearch('theme', 'wows').toString();
        }
        return BaseCaptchaField.prototype.getImageSrc.call(this, { url });
    },
    getContext(context = {}) {
        context.captchaSettings = {
            field_type: _.extract('Settings.Signin.fields.captcha.field_type', 'text'),
            max_length: _.extract('Settings.Signin.fields.captcha.max_length'),
        };
        return BaseCaptchaField.prototype.getContext.call(this, context);
    },
});

export default CaptchaField;



// WEBPACK FOOTER //
// ./registration/static_source/js/registration/dark/signin_fields/captcha.js